import { Button, Card, Col, Form, Row } from "antd";
import { useCreateGameMutation } from "../hooks/useCreateGameMutation";
import { LoadingOverlay } from "../components/LoadingOverlay";
import { useNavigate } from "react-router-dom";
import { OurLayoutForNormalPages } from "../components/OurLayout";
import { Helmet } from "react-helmet-async";

export const CreateGameScreen = () => {
  const navigate = useNavigate();

  const createGameMutation = useCreateGameMutation({
    onSuccess: (gameId) => {
      navigate("/game/play/" + gameId);
    },
  });

  return (
    <OurLayoutForNormalPages>
      <Helmet title={"Wer bin ich - Spiel erstellen"} />
      <Row justify={"center"} style={{ width: "100%" }}>
        <Col md={12} lg={8}>
          <Card title={"Spiel Starten"}>
            {createGameMutation.isLoading && <LoadingOverlay />}

            <Form
              onFinish={() => {
                createGameMutation.mutate();
              }}
              labelCol={{
                md: 24,
                lg: 12,
              }}
            >
              <Form.Item
                wrapperCol={{
                  lg: {
                    offset: 0,
                  },
                }}
              >
                <Button type="primary" block htmlType="submit">
                  Kostenloses Spiel starten
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </OurLayoutForNormalPages>
  );
};
